module.exports = __webpack_public_path__ + "static/5-7d1ec25979cbb6d55804ad20485ced58.png";